import { ElementType } from 'react';

import { Button, ButtonProps } from '../Button';
import { Link, LinkProps } from '../Link';

export type PaginationButtonProps = ButtonProps &
  Partial<LinkProps> & {
    icon: ElementType;
  };

export function PaginationButton({
  href,
  icon: Icon,
  children,
  ...props
}: PaginationButtonProps) {
  if (!href) {
    return (
      <Button
        variant="outline"
        className="rounded-full bg-white"
        disabled
        {...props}
      >
        <Icon className="h-6 w-6" />

        {children}
      </Button>
    );
  }

  return (
    <Link
      href={href}
      variant="outline-button"
      className="rounded-full bg-white"
      {...props}
    >
      <Icon className="h-6 w-6" />

      {children}
    </Link>
  );
}
